import { RewardPointDto } from '../../dto/rewardpoint/rewardpointdto';
import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface RewardPointResponse extends APIResponse 
{
    getRewardPointDto(): RewardPointDto;
}

export class RewardPointResponseDtoImpl extends APIResponseDtoImpl implements RewardPointResponse 
{
    private rewardPointResponseDto : RewardPointDto;

    getRewardPointDto(): RewardPointDto
    {
        return this.rewardPointResponseDto;
    }
    setRewardPointDto(rewardPointResponseDto: RewardPointDto)
    {
        this.rewardPointResponseDto = rewardPointResponseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/rewardpoint/rewardpointresponse.tsx